import { render, staticRenderFns } from "./pos-orders.vue?vue&type=template&id=1c22db1b&"
import script from "./pos-orders.vue?vue&type=script&lang=js&"
export * from "./pos-orders.vue?vue&type=script&lang=js&"
import style0 from "./pos-orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports